import { useCallback, useMemo } from "react";
import styles from "./viewStandaloneLesson.module.scss";
import { useSllGetLessonInfoByUniqueNameQuery } from "@api/graphql-codegen";
import { useLocation, useHistory } from "react-router-dom";
import LessonProgressModal from "@src/components/lesson-progress-modal/LessonProgressModal";
import Spinner from "@src/components/spinner/Spinner";
import { useRolesPermissions } from "@src/hooks";
import { UserRoleEnum } from "@src/types";

const ViewStandaloneLesson = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const uniqueName = pathname.split("/")[2];

  const isSuperAdmin = useRolesPermissions([UserRoleEnum.SuperAdmin]);
  const isAdmin = useRolesPermissions([
    UserRoleEnum.Admin,
    UserRoleEnum.DistrictAdmin,
  ]);

  const { data, loading } = useSllGetLessonInfoByUniqueNameQuery({fetchPolicy: "network-only",
    onCompleted(data) {
      if (!data.sllGetLessonInfoByUniqueName) {
        history.push("/dashboard");
      }
    },
    onError() {
      history.push("/dashboard");
    },
    skip: !uniqueName,
    variables: { input: { uniqueName } }
  });

  const isOpReel = useMemo(() => {
    if (data && data.sllGetLessonInfoByUniqueName) {
      return !!data.sllGetLessonInfoByUniqueName.isOpReel
    }

    return false
  }, [data])

  const handleCloseModal = useCallback(() => {
    if (isOpReel) {
      if (isSuperAdmin) {
        history.push("/super/programs");
      } else if (isAdmin) {
        history.push("/admin/programs");
      } else {
        history.push("/programs");
      }
    } else {
      history.push("standalone/lessons?tab=1");
    }
  }, [history, isAdmin, isOpReel, isSuperAdmin]);

  return (
    <div className={styles.page}>
      {loading ? (
        <div className={styles.spinner}>
          <Spinner />
        </div>
      ) : data?.sllGetLessonInfoByUniqueName ? (
        <LessonProgressModal
          open
          onClose={handleCloseModal}
          lessonId={data.sllGetLessonInfoByUniqueName.id}
        />
      ) : null}
    </div>
  );
};

export default ViewStandaloneLesson;
